import { Injectable } from "@angular/core";


@Injectable({ providedIn: 'root' })
export class TimeZoneService {
  getBrowserTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
